import React from 'react'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import navStyles from '../navigation.module.scss'

const NavItem = ({ hoverTitle, iconName, isActive, size = 24, isMobile }) => (
  <div className={classNames(generalStyles.ml10, navStyles.navItemContainer)}>
    <div
      data-title={hoverTitle}
      className={classNames(
        navStyles.iconContainer,
        isActive && navStyles.iconContainerActive,
        isMobile && navStyles.iconMobileWrapper
      )}
    >
      <IcomoonReact
        iconSet={rebrandIconSet}
        size={size}
        style={isMobile ? { verticalAlign: 'initial' } : null}
        icon={iconName}
      />
    </div>
  </div>
)

export default NavItem
